module.exports = __webpack_public_path__ + "img/img_03.8f788c28.webp";